// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_selected__7Ghvv {
  border: 2px solid #72abab !important; }

.styles_container__aMDbH {
  min-height: 54vh;
  min-width: 36rem; }

.styles_footer__vUkwv {
  height: 4rem;
  padding: 0rem 5rem; }

.styles_labelsContainer__S3vlY {
  min-height: 36vh;
  padding: 0rem 1rem; }
  .styles_labelsContainer__S3vlY span {
    margin: 0.5rem 0.5rem;
    cursor: pointer; }

.styles_inputContainer__1xN5Q {
  min-height: 10vh;
  display: flex;
  align-items: center;
  justify-content: center; }
  .styles_inputContainer__1xN5Q div {
    width: -webkit-fill-available;
    width: 90%; }
  .styles_inputContainer__1xN5Q input {
    width: -webkit-fill-available; }
`, "",{"version":3,"sources":["webpack://./src/modules/mapal/submodules/features/components/AddLabelButton/styles.module.scss"],"names":[],"mappings":"AAGA;EACI,oCAAwC,EAAA;;AAG5C;EACI,gBAAgB;EAChB,gBAAgB,EAAA;;AAGpB;EACI,YAAY;EACZ,kBAAkB,EAAA;;AAItB;EACI,gBAAgB;EAChB,kBAAkB,EAAA;EAFtB;IAIQ,qBAAqB;IACrB,eAAe,EAAA;;AAIvB;EACI,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;EAJ3B;IAMQ,6BAA6B;IAC7B,UAAU,EAAA;EAPlB;IAUQ,6BAA6B,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n\n.selected {\n    border: 2px solid $ocean_blue !important;\n}\n\n.container {\n    min-height: 54vh;\n    min-width: 36rem;\n}\n\n.footer {\n    height: 4rem;\n    padding: 0rem 5rem;\n\n}\n\n.labelsContainer {\n    min-height: 36vh;\n    padding: 0rem 1rem;\n    span {\n        margin: 0.5rem 0.5rem;\n        cursor: pointer;\n    }\n}\n\n.inputContainer {\n    min-height: 10vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    div {\n        width: -webkit-fill-available;\n        width: 90%;\n    }\n    input {\n        width: -webkit-fill-available;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selected": `styles_selected__7Ghvv`,
	"container": `styles_container__aMDbH`,
	"footer": `styles_footer__vUkwv`,
	"labelsContainer": `styles_labelsContainer__S3vlY`,
	"inputContainer": `styles_inputContainer__1xN5Q`
};
export default ___CSS_LOADER_EXPORT___;
